export default __webpack_public_path__ + "static/media/icon_chevron_right_large.be0cdecf.svg";